import React, { Fragment, useContext, useState } from 'react';
import FleetsTextField from '../../../../../../components/TextFields/FleetsTextFields';
import { makeStyles } from '@material-ui/core/styles';
import SelectStates from '../../../../../../components/FormInputs/SelectStates';
import { store } from './reducer';
import { store as mainStore } from '../../../../../../store';
import Button from '@material-ui/core/Button';
import FormHelperText from '@material-ui/core/FormHelperText';
import LinearProgressbar from '@material-ui/core/LinearProgress';

const useStyles = makeStyles((theme) => ({
  root: {
    width: 500,
    display: 'flex',
    flexDirection: 'column',
    '&>*': {
      marginBottom: theme.spacing(1),
    },
  },
  uploadBox: {
    background: '#e0f7fa',
    height: 150,
    border: '1px dashed blue',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

const Form = () => {
  const classes = useStyles();
  const { showMessage, showError } = useContext(mainStore);
  const {
    state: { interests, fleetOptions, files, progress },
    dispatch,
    actions,
  } = useContext(store);
  const [errors, setErrors] = useState({});

  const handleChangeFleetOptions = (selection) => {
    dispatch({ type: 'SELECT_FLEETOPTIONS', payload: selection });
  };
  const handleChangeInterests = (selection) => {
    dispatch({ type: 'SELECT_INTERESTS', payload: selection });
  };
  const handleChangeFile = (e) => {
    const { files } = e.target;
    files?.length && dispatch({ type: 'SELECT_FILES', payload: files });
  };
  const validation = () => {
    const err = {};
    if (!fleetOptions || fleetOptions?.length === 0) {
      err.fleetOptions = 'ناوگان بایستی انتخاب شود';
    }
    if (!interests || interests?.length === 0) {
      err.interests = 'مسیر راننده‌ها بایستی انتخاب شود';
    }
    if (!files || files?.length === 0) {
      err.files = 'فایل اکسل بایستی انتخاب شود.';
    }
    if (Object.entries(err)?.length !== 0) {
      setErrors(err);
      return false;
    }
    setErrors({});
    return true;
  };
  const handleImport = async () => {
    if (!validation()) {
      return;
    }
    const _intersts = [interests];
    const _fleetOptions = fleetOptions;
    try {
      dispatch({ type: 'PROGRESS', payload: true });
      const response = await actions.startImporting({
        interests: _intersts?.map((i) => i.value),
        fleetOptions: _fleetOptions?.map((f) => f._id),
        file: files[0],
      });
      if (response.ok) {
        showMessage(response.messages);
      }
    } catch (error) {
      showError(error);
    }
    dispatch({ type: 'PROGRESS', payload: false });
  };

  return (
    <div className={classes.root}>
      <FleetsTextField
        selection={fleetOptions || []}
        single
        onChange={handleChangeFleetOptions}
        error={errors?.fleetOptions ? errors.fleetOptions : false}
      />
      <SelectStates
        state={interests || []}
        onSelect={handleChangeInterests}
        placeholder="انتخاب مسیر"
        error={errors?.interests ? errors?.interests : false}
      />

      <Button className={classes.uploadBox} component="label">
        <input
          type="file"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          style={{ display: 'none' }}
          onChange={handleChangeFile}
        />
        {files?.length ? `یک فایل انتخاب شده است` : `ایمپورت مخاطبین ...`}
        {errors?.files && (
          <FormHelperText error={true}>فایل بایستی انتخاب شود</FormHelperText>
        )}
      </Button>
      <Button
        onClick={handleImport}
        variant="contained"
        size="large"
        color="secondary"
        disabled={progress ? true : false}
      >
        شروع ایمپورت
      </Button>
      {progress && <LinearProgressbar style={{ margin: '10 0' }} />}
    </div>
  );
};

export default React.memo(Form);
